// extracted by mini-css-extract-plugin
export default {"rankItem":"PotViewItem_rankItem__BNxak","item":"PotViewItem_item__IzBaN","bg":"PotViewItem_bg__1hTOR"};